module.exports = __webpack_public_path__ + "static/media/let3.7ca9a2ad.JPG";